import {Routes} from "@angular/router";
import {WorkflowEndcustomerAddTrialPhonenumberComponent} from "./workflow-endcustomer-add-trial-phonenumber.component";

export const workflowEndcustomerAddTrialPhonenumberRouting: Routes = [
    { path: 'trial-phonenumber', component: WorkflowEndcustomerAddTrialPhonenumberComponent, children: [
            { path: 'add-phonenumber', component: WorkflowEndcustomerAddTrialPhonenumberComponent },
            { path: 'completed', component: WorkflowEndcustomerAddTrialPhonenumberComponent },
    ]},
]